var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"137bb4dbac6129a776a4e8eff45df64e60438fb0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["war-and-peace@fictive-kin"]={id:"137bb4dbac6129a776a4e8eff45df64e60438fb0"};
      